import { useQuery } from "@tanstack/react-query";

import {
  getReportHistory,
  validateReportHistoryFilters,
  DEFAULT_PAGE_SIZE,
} from "../services/case-manager/reportHistory";
import { handleApiError } from "../utils/handleApiError";

const TWO_MINUTES = 2 * 60 * 1000;

/**
 * OOR Report History (SCRUM-138).
 *
 * Filters map straight onto the GET history query params. When start/end
 * date are mismatched (only one provided), the request is withheld and
 * `validationError` carries the message the caller should show instead.
 */
export const useReportHistory = ({
  enabled = true,
  provider,
  status,
  startDate,
  endDate,
  page = 1,
  pageSize = DEFAULT_PAGE_SIZE,
} = {}) => {
  const validationError = validateReportHistoryFilters({
    startDate,
    endDate,
    page,
    pageSize,
  });

  const query = useQuery({
    queryKey: [
      "oor-report-history",
      provider,
      status,
      startDate,
      endDate,
      page,
      pageSize,
    ],
    queryFn: () =>
      getReportHistory({ provider, status, startDate, endDate, page, pageSize }),
    enabled: enabled && !validationError,
    keepPreviousData: true,
    staleTime: TWO_MINUTES,
    refetchOnWindowFocus: false,
    onError: (error) => handleApiError(error),
  });

  return { ...query, validationError };
};

export default useReportHistory;
